import MuiTextField, { TextFieldProps } from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { SxProps, Theme, useTheme } from '@mui/material/styles';

type CustomTextFieldProps = TextFieldProps & {
  label?: string;
  formHelperSx?: SxProps<Theme> | undefined;
};

const CustomTextField = ({ label, formHelperSx, error, helperText, ...props }: CustomTextFieldProps) => {
  const theme = useTheme();

  return (
    <Stack gap={4} sx={{ width: '100%' }}>
      {label && (
        <Typography variant='h2' fontWeight='bold'>
          {label}
        </Typography>
      )}
      <FormControl error={error} fullWidth>
        <MuiTextField
          {...props}
          sx={{
            ...props.sx,
            '& .MuiOutlinedInput-root': {
              ...(error && {
                '& fieldset': {
                  borderColor: `${theme.palette.error.main} !important`
                }
              })
            }
          }}
        />
        {helperText && <FormHelperText sx={formHelperSx}>{helperText}</FormHelperText>}
      </FormControl>
    </Stack>
  );
};

export default CustomTextField;
